import { Spinner } from "native-base";

export default Spinner;